var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v(" Личная информация ")]),_c('v-card-text',[_c('property-form',{attrs:{"value":_vm.user,"fields":[
            'email',
            'first_name',
            'last_name',
            'referral_code',
            'phone',
            'inn',
            'ogrn',
          ].reduce((a, v) => {
            a[v] = { visible: true };
            return a;
          }, {})},on:{"input":_vm.doUpdateUser}})],1)],1),_c('v-card',{staticClass:"my-5"},[_c('v-card-title',[_vm._v(" Глобальные настройки ")]),_c('v-card-text',[_c('property-form',{attrs:{"value":_vm.propertiesValues,"fields":_vm.propertiesFields,"simulate-reactivity":true},on:{"input":_vm.saveProperties}})],1)],1),_c('v-card',{staticClass:"my-5"},[_c('v-card-title',{staticClass:"d-flex justify-space-between align-center"},[_c('span',[_vm._v("Новости")]),_c('v-btn',{staticClass:"pa-5 px-sm-10 white--text",attrs:{"color":"#d86568","large":"","rounded":""},on:{"click":_vm.addNews}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-plus")]),_vm._v(" Добавить новость ")],1)],1),_c('v-card-text',[_c('object-grid-advanced',{attrs:{"value":_vm.news,"field-defs":[
          { text: 'Заголовок', value: 'title', width: '35%' },
          { text: 'Активна', value: 'activeDisplay', width: '15%' },
          { text: 'Дата создания', value: 'createdAtDisplay', width: '25%' },
          { text: 'Истекает', value: 'expiresAtDisplay', width: '25%' },
        ],"show-actions":{
          edit: true,
          delete: true,
        },"instanceId":`newsSearch`},on:{"doEditItem":_vm.editNews,"doDeleteItem":_vm.deleteNews}})],1)],1),_c('object-grid-advanced',{staticClass:"mt-5",attrs:{"value":_vm.categories,"field-defs":[
      { text: 'Категория', value: 'name', width: '30%' },
      {
        text: 'Стоимость курса',
        value: 'course_price',
        width: '20%',
      },
      {
        text: 'Количество сессий',
        value: 'session_count',
        width: '20%',
      },
      {
        text: 'Стоимость сессии',
        value: 'session_price',
        width: '20%',
      },
    ],"show-actions":{
      edit: true,
    },"instanceId":`preferenceSearch_active`},on:{"doEditItem":_vm.editCategoryPrice}}),_c('error-message-wrapper',{ref:"error_wrapper"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }